import Ajax from '@utils/ajax';

export default {
  fetch(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/rec_objects`,
      ...options,
    });
  },

  get(group, recObject, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/rec_objects/${recObject.id}`,
      ...options,
    });
  },

  destroy(group, recObject, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_objects/${recObject.id}`,
      data: {
        _method: 'DELETE',
        ...data,
      },
      ...options,
    });
  },

  updateSortOrder(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_objects/change_sort_order`,
      data: {
        sections: data,
      },
      ...options,
    });
  },

  moveToSection(group, recObject, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_objects/${recObject.id}/move_to_section`,
      data: data,
      ...options,
    });
  },
};
